var exports = {
  "EZ": "xaee3c4fa--5a1498--likes-popup",
  "WT": "xaee3c4fa--5a1498--dislikes-popup",
  "f1": "xaee3c4fa--5a1498--advice-card-header-footerbar_like-tip",
  "J_": "xaee3c4fa--5a1498--advice-card-header-footerbar_like-tip-avatar",
  "JP": "xaee3c4fa--5a1498--advice-card-header-footerbar_like-tip-avatar-outer",
  "q4": "xaee3c4fa--5a1498--advice-card-header-footerbar_like-tip-avatar-inner",
  "Ti": "xaee3c4fa--5a1498--advice-card-header-footerbar_like-tip-avatar-img",
  "$2": "xaee3c4fa--5a1498--advice-card-header-footerbar_like-tip-show-all",
  "Im": "xaee3c4fa--5a1498--advice-card-article-nav_likes",
  "Ct": "xaee3c4fa--5a1498--advice-card-article-nav_dislikes",
  "qc": "xaee3c4fa--5a1498--advice-card-article-nav_likes-icon",
  "ot": "xaee3c4fa--5a1498--advice-card-article-nav_dislikes-icon",
  "a": "xaee3c4fa--5a1498--advice-card-article-nav_likes-count",
  "sV": "xaee3c4fa--5a1498--advice-card-article-nav_dislikes-count",
  "UG": "xaee3c4fa--5a1498--advice-card-article-nav_likes-liked",
  "dk": "xaee3c4fa--5a1498--advice-card-article-nav_dislikes-disabled",
  "nv": "xaee3c4fa--5a1498--advice-card-article-nav_likes-disabled",
  "zQ": "xaee3c4fa--5a1498--advice-card-article-nav_dislikes-comments",
  "tv": "xaee3c4fa--5a1498--advice-card-article-nav_likes-comments",
  "QX": "xaee3c4fa--5a1498--advice-card-article-nav-likebar",
  "WN": "xaee3c4fa--5a1498--advice-card-modal",
  "XZ": "xaee3c4fa--5a1498--advice-card-modal-heading",
  "GC": "xaee3c4fa--5a1498--advice-card-modal-heading-likebar",
  "vJ": "xaee3c4fa--5a1498--advice-card-modal-heading-likebar_helper",
  "Pg": "xaee3c4fa--5a1498--advice-card-modal-heading-likebar-disabled",
  "It": "xaee3c4fa--5a1498--advice-card-modal-main",
  "Em": "xaee3c4fa--5a1498--advice-card-modal-main-item-avatar",
  "sB": "xaee3c4fa--5a1498--advice-card-modal-main-item-avatar-outer",
  "Fv": "xaee3c4fa--5a1498--advice-card-modal-main-item-avatar-inner",
  "Yl": "xaee3c4fa--5a1498--advice-card-modal-main-item-avatar-img",
  "mR": "xaee3c4fa--5a1498--advice-card-modal-main-item_name",
  "rF": "xaee3c4fa--5a1498--advice-card-article-nav-likebar-comments",
  "zJ": "xaee3c4fa--5a1498--likes-popup-comments",
  "Jt": "xaee3c4fa--5a1498--dislikes-popup-comments",
  "pF": "xaee3c4fa--5a1498--advice-card-header-footerbar_like-tip__hidden-block",
  "gT": "xaee3c4fa--5a1498--advice-card-header-footerbar_like-tip__hidden-block-comments",
  "n5": "xaee3c4fa--5a1498--advice-card-article-nav_likes-wrap",
  "vV": "xaee3c4fa--5a1498--advice-card-article-nav_dislikes-wrap",
  "AU": "xaee3c4fa--5a1498--advice-card-article-nav_likes-wrap-card",
  "_L": "xaee3c4fa--5a1498--advice-card-article-nav_dislikes-wrap-card",
  "Ui": "xaee3c4fa--5a1498--advice-card-article-nav_dislikes-comments-wrap",
};

module.exports = exports;
